import React from 'react'
import classNames from 'classnames'
import './style.scss'

const InfoBox = ({ color = 'label', background = 'card-hover', title, text, rounded = true, blockTitle, textSize, titleWeight, children }) => {

  const wrapperClass = classNames({
    'viso-info-box__wrapper': true,
    'viso-info-box__wrapper--rounded': rounded,
    'viso-info-box__wrapper--block': blockTitle,
    [`viso-info-box__wrapper--${textSize}`]: textSize,
    [`viso-bg-${background} viso-text-${color}`]: true
  })

  const titleClass = classNames({
    'viso-info-box__title': true,
    'viso-info-box__title--block viso-text-text': blockTitle,
    [`viso-info-box__title--${titleWeight}`]: titleWeight
  })

  return (
    <div className='viso-info-box'>
      <div className={wrapperClass}>
        {title && <span className={titleClass}>{title}</span>}
        {text && <span className='viso-info-box__text'>{text}</span>}
        {children}
      </div>
    </div>
  )
}

export default InfoBox